import React from 'react';
import { toast } from 'react-toastify';
import { useCreateGpsIntegration } from '@area-restrita/api-client/endpoints/gps-integrations/gps-integrations.gen';

import Dialog from '@/components/template/Dialog';

import GpsIntegrationForm from './GpsIntegrationForm';

interface CreateGpsIntegrationModalProps {
  trigger: React.ReactNode;
}

const CreateGpsIntegrationModal: React.FC<CreateGpsIntegrationModalProps> = ({
  trigger,
}) => {
  const { mutateAsync: createGpsIntegration, isPending } =
    useCreateGpsIntegration();

  return (
    <Dialog
      title="Nova Integração GPS"
      description="Configure uma nova integração para rastreamento GPS de veículos."
      trigger={trigger}
    >
      {({ handleClose }) => (
        <div className="py-4">
          <GpsIntegrationForm
            onSubmit={async (data) => {
              await createGpsIntegration(
                { data },
                {
                  onSuccess: async () => {
                    toast.success('Integração GPS criada com sucesso!');
                  },
                  onError: () => {
                    toast.error(
                      'Erro ao criar integração GPS. Tente novamente.',
                    );
                  },
                },
              );
              handleClose();
            }}
            isLoading={isPending}
          />
        </div>
      )}
    </Dialog>
  );
};

export default CreateGpsIntegrationModal;
